import React from 'react';
import NavigationBar from '../nav_bar/navigation_bar';
import Skills from '../skills/skills';

const SkillsPage = () => {
    return (
        <div className="skills-page">
            <NavigationBar />

            <main className="skills-main">
                <Skills />
            </main>

        </div>
    );
};

export default SkillsPage;